'use client';

import { useTranslations } from 'next-intl';
import { Button } from '@terra/ui-design-system';
import { Add01Icon } from '@terra/ui-icons';

type MemoriesToolbarActionsProps = {
  activeTab: 'application' | 'user_preferences';
  onAddClick: () => void;
};

export function MemoriesToolbarActions({
  activeTab,
  onAddClick,
}: MemoriesToolbarActionsProps) {
  const t = useTranslations('memories');

  return (
    <Button
      size="xs"
      variant="outline"
      colorPalette="terra"
      onClick={onAddClick}
    >
      <Add01Icon size={14} />
      {activeTab === 'user_preferences'
        ? t('preferences.addButton')
        : t('addMemory')}
    </Button>
  );
}
